import { ClassCreatedModalTranslations } from "./types";

export const enTranslations: ClassCreatedModalTranslations = {
    title: "Class created with auth code",
    subtitle: "Share this code with your students.",
    copyConfirmation: "Copied!"
};